export default __webpack_public_path__ + "fonts/icomoon.ttf?399216922be934ab0bc999de2407a489";